import React, { Component } from "react";

export default class Divider extends Component {
    render() {
        return (
            <div className="ubx-commons divider">
                <div className="divider-text">{this.props.text}</div>
                <hr className="divider-line" />
            </div>
        );
    }
}
